import { Component } from '@angular/core';
import { ItemAttributesStoreService } from '../item-attributes-store.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { promptFormGroupFactory } from '../add-attribute/add-attribute.component';
import { take } from 'rxjs/operators';
import { ItemAttribute } from '../../../models/item';
import { TestIdDirective } from '../../directives/test-id.directive';
import { MatButton } from '@angular/material/button';
import { EditAttributeFormComponent } from '../edit-attribute-form/edit-attribute-form.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-edit-attribute',
    templateUrl: './edit-attribute.component.html',
    standalone: true,
    imports: [NgIf, EditAttributeFormComponent, MatButton, TestIdDirective]
})
export class EditAttributeComponent {
  form = new FormGroup({
    name: new FormControl<string>('', Validators.required),
    starting_value: new FormControl<string>('', Validators.required),
    data_type: new FormControl<'string' | 'number' | 'boolean' | 'date'>(
      'string',
      Validators.required
    ),
    type: new FormControl('custom'),
    prompts: new FormGroup({
      on_hire: promptFormGroupFactory(),
      off_hire: promptFormGroupFactory(),
      workshop_job_complete: promptFormGroupFactory(),
      collection: promptFormGroupFactory(),
      delivery: promptFormGroupFactory()
    }),
    append_to_hire_item_notes: new FormControl<boolean>(false),
    display_on_summary: new FormControl<boolean>(false),
    display_on_public_page: new FormControl<boolean>(false)
  });

  showForm = false;

  constructor(private store: ItemAttributesStoreService) {
    this.store.editingAttribute$.pipe(take(1)).subscribe((attribute) => {
      this.form.patchValue(attribute);
      this.form.controls.starting_value.disable();
      this.form.controls.data_type.disable();
      this.form.controls.type.disable();
      if (attribute.type !== 'custom') {
        this.form.controls.name.disable();
      }
      this.showForm = true;
    });
  }

  save() {
    this.store.updateAttribute(this.form.value as Partial<ItemAttribute>);
  }

  cancel() {
    this.store.setView('list');
  }
}
